export default __webpack_public_path__ + "static/media/pic2.1c7ec971.jpg";